
import { useNavigate } from "react-router-dom";
import { IconButton, Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useVehiculoStore } from "../../../../store";
import { TooltipAndIcon } from "../../components/TooltipAndIcon";
import { AlertScreen } from "../../components/AlertScreen";

import Swal from "sweetalert2";
import dayjs from "dayjs";





export const TablaListadoVehiculos = ({ data, page=0, chagePage=null }) => {


    const navigate = useNavigate();
    const { startBloquearVehiculo } = useVehiculoStore();



    const eliminarLote = ( v ) => {
        Swal.fire({
            title: 'Eliminar Vehiculo',
            text: `¿Esta Seguro De Eliminar Este Vehiculo: ${ v.placa }?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si, Eliminar' 
        }).then( ( result ) => {
            if(result.value){
                startBloquearVehiculo( v );
            }
        });
    }
    
    
    const handleActualizarLote = (uid) => {
        navigate(`/admin/vehi/${uid}/edit`);
    }
    

    
    const handleImgSeguros = (uid) => {
        navigate(`/admin/img/${uid}/seguros`);
    }




    return (
        <>
            {(data?.length > 0) 
            ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt: 4 }}>
                    <TableContainer sx={{ maxWidth:'100%'}}>
                        <Table sx={{ minWidth: 700 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width:'5%'}}>A.</TableCell>
                                    <TableCell sx={{width:'8%'}}>PLACA</TableCell>
                                    <TableCell sx={{width:'8%'}}>MODELO</TableCell>
                                    <TableCell sx={{width:'20%'}}>CONDUCTOR</TableCell>
                                    <TableCell sx={{width:'15%'}}>VENCIMIENTO SOAT</TableCell>
                                    <TableCell sx={{width:'15%'}}>VENCIMIENTO TECNO</TableCell>
                                    <TableCell sx={{width:'15%'}}>VENCIMIENTO RIESGO</TableCell>
                                    <TableCell sx={{width:'20%'}}>OPCIONES</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {data.map( ( v ) => (
                            <TableRow key={ v.id } >
                                <TableCell >
                                    {(v.status)
                                    ?   <IconButton className='boton-estado trru'/>
                                    :   <IconButton className='boton-estado fall'/>
                                    }
                                </TableCell>
                                <TableCell> { v.placa } </TableCell>
                                <TableCell> { v.modelo } </TableCell>
                                <TableCell>
                                    {( v.conductor )
                                    ? v.conductor.nombre
                                    : <Typography variant="span" color="error">no disponible</Typography>
                                    } 
                                </TableCell>
                                <TableCell> { dayjs(v.soatFin).format('DD[/]MMMM[/]YY').toUpperCase() } </TableCell>
                                <TableCell> { dayjs(v.tecnoFin).format('DD[/]MMMM[/]YY').toUpperCase() } </TableCell>
                                <TableCell> { dayjs(v.todoRiesgoFin).format('DD[/]MMMM[/]YY').toUpperCase() } </TableCell>
                                <TableCell>
                                    <TooltipAndIcon
                                        titulo='Ver Imaggenes'
                                        icono='photo'
                                        onClick={ () => handleImgSeguros(v.id) }
                                    />

                                    <TooltipAndIcon
                                        titulo='Actualizar Vehiculo'
                                        icono='setting'
                                        onClick={ () => handleActualizarLote( v.id ) }
                                    />

                                    <TooltipAndIcon
                                        titulo='Eliminar Vehiculo'
                                        icono='eliminar'
                                        onClick={ () => eliminarLote( v.id ) }
                                        color='red'
                                    />
                                </TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                        <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                            <Pagination count={Math.ceil(50 / 50)} disabled={Math.ceil(50 / 50) === 1}
                                variant="outlined" page={page + 1} color="primary" 
                                onChange={ (_, newValor) => chagePage(newValor) } 
                            />
                        </Stack>
                    </TableContainer>
                </Paper>

            :   <AlertScreen title="No hay vehiculos creados por el momento..."/>
            }
        </>
    )



}
